import { Select, SelectProps } from 'antd'
import React, { useMemo } from 'react'
import { LoaderMetadata } from '../../models/LLM';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { sectionLabelsSelector } from '../../slices/sectionsSlice';

type Props = {
  value?: string;
  loaders?: LoaderMetadata[];
  onChange?: SelectProps['onChange'];
}

export default function LoaderClassDropdown({ value, loaders, onChange }: Props) {

  const loaderLabels = useSelector((state: RootState) => sectionLabelsSelector(state, "loaders"));

  const options = useMemo(() => {
    return loaders?.map(opt => ({
      label: (
        <>
          <h6 className="mb-0">{opt.name}</h6>
          <span className="text-muted">{opt.description}</span>
        </>
      ),
      value: opt.name,
    })) || [];
  }, [loaders]);

  return (
    <Select
      loading={!options}
      virtual={true}
      options={options}
      className="w-100 h-auto"
      showSearch
      value={value}
      onChange={onChange}
      placeholder={`Select ${loaderLabels.singular} class...`}
      allowClear
    />
  )
}